import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './msTeamsIntegrationManager.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import * as teamsJs from "../npmTypings";
import { ExtraHelpers } from "../../../more/Helpers";
import teamsTabSetup from '../tabSetup/teamsTabSetup';

class msTeamsIntegrationManager extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private teamsApp:typeof teamsJs.app;
    private teamsJs:typeof teamsJs;

    private readonly msTeamsSdkScriptName: string = "MicrosoftTeams.min.js";

    private teamsTabId: string = "unknown";
    private configBtnContainer:HTMLDivElement;
    private isReady: boolean = false;
    private settingsBtn:HTMLButtonElement;
    private async initDependencys(callback: Function) {
        const injectionDependencys: Array<{ url: string, type: string }> = [
            {
                url: window.appRoot + "Content/MsTeamsIntegration/" + this.msTeamsSdkScriptName,
                type: "js"
            }
        ];
        for (let elem of injectionDependencys) {
            if ((document.querySelectorAll(`link[rel="stylesheet"][href="${elem.url}"], script[src="${elem}"]`).length > 0) == false) {
                await this.loadDependency(elem);
            }
        }
        if (typeof callback == 'function') {
            callback();
        }
    }

    private async loadDependency(dependency: { url: string, type: string }) {
        switch (dependency.type) {
            case "js":
                return new Promise((resolve, reject) => {
                    let hideDefine = typeof window["define"] != 'undefined'; //ist false webpack for example
                    let newJsElem = document.createElement("script");
                    newJsElem.src = dependency.url;
                    //dadurch wenn window.define existiert probiert teams-js sich über den AMD loader zu laden
                    //natuerlich versteht das der dojo-loader nicht
                    //um teams-js auszutricksen verschwinded nach document.onload window.define einfach kurz
                    //dann setzt teams-js den module export auf window.microsoftTeams
                    let originalDefine:any;
                    if (hideDefine){
                        originalDefine = window["define"];
                        const defineProxy = new Proxy(originalDefine, {
                            get:()=>{
                                let isAccessedByTeamsJsScript = false;
                                /*try{
                                    throw new Error();
                                }catch(err){
                                    const stackTraceTxt:string = err.stack;
                                    if (typeof stackTraceTxt == 'string'){
                                        let stackTrace: string[];
                                        if (stackTraceTxt.includes("\n")){
                                            stackTrace = stackTraceTxt.split("\n");
                                        }else{
                                            stackTrace = [];
                                        }
                                        if (Array.isArray(stackTrace)){
                                            if (stackTrace.length >= 2){
                                                if (stackTrace[1].includes(this.msTeamsSdkScriptName)){
                                                    isAccessedByTeamsJsScript = true;
                                                }
                                            }
                                        }
                                    }
                                }*/ //scheint auch ohne stack trace zu funktionieren, auskommentiert drinnen gelassen als evtl. notloesung
                                isAccessedByTeamsJsScript = true;
                                if (isAccessedByTeamsJsScript){
                                    return undefined;
                                }else{
                                    console.trace();
                                    return originalDefine;
                                }
                            }
                        });
                        console.info("hiding amd loader from teams sdk, if anything breaks (dojo-loader) this might be the reason why");
                        window["define"] = defineProxy;
                    }
                    newJsElem.onload = () => {
                        if (hideDefine){
                            window["define"] = originalDefine;
                        }
                        console.info("teams-js loaded, restored amd loader");
                        resolve(true)
                    };
                    newJsElem.onerror = (e)=>{
                        if (hideDefine){
                            window["define"] = originalDefine;
                        }
                        console.error("failed to load teams sdk js", e);
                        reject(e);
                    };
                    document.head.appendChild(newJsElem);
                });
                break;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        topic.subscribe("MsTeamsIntegration/ToggleTabSettingsButton", lang.hitch(this, (isVisible:boolean)=>{
            if (typeof isVisible == 'boolean'){
                if (isVisible){
                    this.configBtnContainer.classList.remove("w3-hide");
                }else{
                    this.configBtnContainer.classList.add("w3-hide");
                }
            }
        }));
    }

    public async init(){
        let hasRole = await this.hasUserRoleAsync("TeamsIntegration_Access");
        if (!hasRole ){
            //User hat kein zugriff auf teams, skippen
            return;
        }
        let isRunningInReverseProxy = false;
        let baseDomainMatches: Array<string> = ["moredms.com", "devtunnels.ms"];
        for (let domainMatch of baseDomainMatches){
            if (window.location.host.toLowerCase().includes(domainMatch)){
                isRunningInReverseProxy = true;
                break;
            }
        }
        if (isRunningInReverseProxy){
            //teams sdk laden
            this.initDependencys(lang.hitch(this, this.initTeams));
        }else{
            console.info("reverse-proxy is not detected, skipping loading teams sdk");
            // 4 dev
            topic.subscribe("MsTeamsIntegration/dev__overwriteTabId", lang.hitch(this, (newId:string)=>{
                this.teamsTabId = newId ?? "unknown";
                //set/get state fuer dev
                this.teamTabAppStateQueue = new ExtraHelpers.AsyncOperationQueue();
                window["msTeamsSimpleApi"]["helperFn"] = {
                    stateJobQueue: this.teamTabAppStateQueue,
                    stateGet: lang.hitch(this, this.global__getState),
                    stateSet: lang.hitch(this, this.global__setState),
                    getTabID: lang.hitch(this, ()=>{
                        return this.teamsTabId;
                    }),
                };
                this.isReady = true;
                this.setTabConfigBtn();
            }));
        }
    }

    private async initTeams() {
        if (typeof window["microsoftTeams"] == 'undefined'){
            console.error("cannot load ms teams sdk");
            return;
        }
        this.teamsApp = window["microsoftTeams"]["app"];
        this.teamsJs = window["microsoftTeams"];

        if (this.hasFeature("MsTeamsIntegration", "enableMainlandChinaTeams")){
            // "Cross-cloud communication through SDK is restricted for security reasons",
            // deshalb enablen wir es hier auch nur wenn wir es brauchen (falls wir es jemals brauchen)
            try{
                await this.teamsApp.initialize(["https://teams.microsoftonline.cn"]);
            }catch{}
        }else{
            try{
                await this.teamsApp.initialize();
            }catch{}
        }

        let isInit = false;
        try{
            if ((typeof this.teamsApp.isInitialized == 'function')) {
                isInit = this.teamsApp.isInitialized();
            }
        }catch{}
        if (isInit == false){
            console.info("ms teams browser window not found, skipping");
            return;
        }
        this.teamsApp.notifyAppLoaded(); //damit der user mit der app interagieren kann
        await this.teamsApp.notifySuccess();
        //globalen teams context setzen...
        window.msTeamsSimpleApi.isCurrentlyRunningInTeamsTab = true;
        let context = await this.teamsApp.getContext();
        let frameContext = await this.teamsApp.getFrameContext();
        this.teamsTabId = context["page"]["id"];
        if (typeof this.teamsTabId != 'string'){
            this.teamsTabId = "unknown";
        }
        window.msTeamsSimpleApi["metadata"] = {
            context:context,
            frameContext:frameContext,
        };
        window.msTeamsSimpleApi["actions"] = {
            openDeepLink:this.teamsApp.openLink,
        }
        try{
            if (this.teamsJs.chat.isSupported()) {
                window.msTeamsSimpleApi.actions["openChat"] = this.teamsJs.chat.openChat;
                window.msTeamsSimpleApi.actions["openGroupChat"] = this.teamsJs.chat.openGroupChat;
            }
        }catch{}
        try{
            if (this.teamsJs.call.isSupported()) {
                window.msTeamsSimpleApi.actions["startCall"] = this.teamsJs.call.startCall;
            }
        }catch{}
        try{
            if (this.teamsJs.mail.isSupported()){
                window.msTeamsSimpleApi.actions["composeMail"] = this.teamsJs.mail.composeMail;
                window.msTeamsSimpleApi.actions["openMailItem"] = this.teamsJs.mail.openMailItem;
            }
        }catch{}
        if (this.teamsJs.meeting?.hasOwnProperty("joinMeeting")){
            window.msTeamsSimpleApi.actions["joinMeetingByUrl"] = this.teamsJs.meeting.joinMeeting;
        }
        try{
            if (this.teamsJs.calendar.isSupported()){
               window.msTeamsSimpleApi.actions["composeMeeting"] = this.teamsJs.calendar.composeMeeting;
               window.msTeamsSimpleApi.actions["openItemInTeamsCalendar"] = this.teamsJs.calendar.openCalendarItem;
            }
        }catch{}
        try{
            if (this.teamsJs.pages.isSupported()){
                window.msTeamsSimpleApi.actions["shareDeepLink"] = this.teamsJs.pages.shareDeepLink;
                window.msTeamsSimpleApi.actions["returnFocus"] = this.teamsJs.pages.returnFocus;
                window.msTeamsSimpleApi.actions["setCurrentFrame"] = this.teamsJs.pages.setCurrentFrame;
            }
        }catch{}
        try{
            if (this.teamsJs.people.isSupported()){
                window.msTeamsSimpleApi.actions["launchPeoplePicker"] = this.teamsJs.people.selectPeople;
            }
        }catch{}

        let fnHandleThemeChange = (theme: string) => {
            // alle moeglichen values zu finden ist nicht so einfach:
            // https://learn.microsoft.com/en-us/microsoftteams/platform/tabs/how-to/access-teams-context?tabs=Json-v2%2Cteamsjs-v2%2Cdefault#get-context-by-inserting-url-placeholder-values
            let isLightThemed: boolean = true; //default = light
            const lightThemes: Array<string> = ['light', 'default', 'glass', 'contrast'];
            const darkThemes: Array<string> = ['dark'];
            if (lightThemes.includes(theme)) {
                isLightThemed = true;
            }
            if (darkThemes.includes(theme)) {
                isLightThemed = false;
            }
            if (isLightThemed) {
                window.themeToggler.setTheme('light');
            } else {
                window.themeToggler.setTheme('dark');
            }
            topic.publish("MsTeamsIntegration/ClientThemeChange", theme);
        };
        this.teamsApp.registerOnThemeChangeHandler(fnHandleThemeChange);
        fnHandleThemeChange(window.msTeamsSimpleApi.metadata.context.app.theme); //jetziges theme setzen

        this.teamTabAppStateQueue = new ExtraHelpers.AsyncOperationQueue();
        window["msTeamsSimpleApi"]["helperFn"] = {
            stateJobQueue:this.teamTabAppStateQueue,
            stateGet: lang.hitch(this, this.global__getState),
            stateSet: lang.hitch(this, this.global__setState),
            getTabID: lang.hitch(this, () => {
                return this.teamsTabId;
            }),
        };

        //tabID fetchen (graph api)
        console.info("try fetching tabId from graphEntityID");
        try{
            let prom = new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_MSTeams_TabAppHelpers_GraphEntityId_to_tabId",
                    {
                        teamID: context?.team?.groupId ?? "",
                        channelID: context?.channel?.id ?? "",
                        graphEntityID: this.teamsTabId ?? ""
                    },
                    lang.hitch(this, (result: any) => {
                        resolve(result);
                    }),
                    lang.hitch(this, (err) => {
                        console.error(err.Message);
                        reject(err);
                    })
                );
            });
            try{
                let res:{tabID:string} = await prom as any;
                window.msTeamsSimpleApi.metadata.actualTabID = res.tabID ?? null;
            }catch(e){
                /* wenn z.b. graph nicht zugelassen ist, dann ignorieren wir das hier einfach */
                console.warn("could not fetch actual tab id for this tab:", e);
            }
        }catch{}

        //global benachrichtigen, das teams verfuegbar ist
        topic.publish("MsTeamsIntegration/Authenticated", window.msTeamsSimpleApi);
        this.isReady = true;
        this.setTabConfigBtn();
    }

    private teamTabAppStateQueue:ExtraHelpers.AsyncOperationQueue;
    private async global__setState(identifier: string, content: string):Promise<boolean> {
        if ((identifier.length > 2048) || (content.length > 2147483647)){
            throw "parameter length exceeded";
            return;
        }
        let setStateFn = async ()=>{
            return new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_MSTeams_TabAppHelpers_TabState_Set",
                    {
                        identifier: identifier,
                        tabId: this.teamsTabId,
                        content: content
                    },
                    (response: object) => {
                        let respString;
                        if (typeof response != 'string') {
                            respString = JSON.stringify(response);
                        } else {
                            respString = response as string;
                        }
                        resolve(respString)
                    },
                    (errorResponse) => {
                        console.error(errorResponse);
                        reject(JSON.stringify({ success: false }));
                    }
                );
            });
        };
        let fnResult:string = await this.teamTabAppStateQueue.enqueue(setStateFn) as any;
        let fnResultObj = JSON.parse(fnResult);
        console.info("set state", identifier,fnResultObj);
        return fnResultObj["success"] as boolean;
    }
    private async global__getState(identifier: string):Promise<string> {
        if (identifier.length > 2048) {
            throw "parameter length exceeded";
            return;
        }
        let getStateFn = async () => {
            return new Promise((resolve, reject) => {
                    this.RequestManager.callfunction(
                        "Webtool_MSTeams_TabAppHelpers_TabState_Get",
                        {
                            identifier: identifier,
                            tabId: this.teamsTabId,
                        },
                        (response: object) => {
                            let respString;
                            if (typeof response != 'string') {
                                respString = JSON.stringify(response);
                            } else {
                                respString = response as string;
                            }
                            resolve(respString)
                        },
                        (errorResponse) => {
                            console.error(errorResponse);
                            reject(JSON.stringify({ success: false, content:"" }));
                        }
                    );
                }
            )};
        let fnResult:string = await this.teamTabAppStateQueue.enqueue(getStateFn) as any;
        let fnResultObj: object = JSON.parse(fnResult);
        console.info("get state", identifier, fnResultObj);
        return fnResultObj["content"] as string;
    }

    private setTabConfigBtn(){
        let container = document.createElement('div');
        container.classList.add("msTeamsIntegrationManager");
        this.placeAt(container);
        document.body.appendChild(container);
        this.configBtnContainer.classList.remove("w3-hide");
    }

    private _onClick_SettingsBtn(ev:Event){
        let configWidget = new teamsTabSetup();
        configWidget.showAsDlg();
    }

    private setBtnHidden(hideButton: boolean | 'disable' | 'enable' = false){
        if (this.isReady == false){
            return;
        }
        this.settingsBtn.disabled = false;
        this.configBtnContainer.classList.remove("w3-hide");
        if (typeof hideButton == 'boolean'){
            if (hideButton){
                this.configBtnContainer.classList.add("w3-hide");
            }
        }
        if (typeof hideButton == 'string'){
            if (hideButton == 'disable'){
                this.settingsBtn.disabled = true;
            }
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    constructor(){
        super(...(arguments as unknown as []));
        window["msTeamsSimpleApi"] = {
            isCurrentlyRunningInTeamsTab: false,
            onIsTeams:(fn:Function)=>{
                if (typeof fn != 'function'){
                    return;
                }
                if (window["msTeamsSimpleApi"]["isCurrentlyRunningInTeamsTab"] == true){
                    fn();
                }else{
                    topic.subscribe("MsTeamsIntegration/Authenticated", ()=>{
                        fn();
                    });
                }
            },
            managerHideSettingsButton:lang.hitch(this, this.setBtnHidden)
        };
    }
}

export default mdsWidget(msTeamsIntegrationManager);
